import React from 'react';
import {
  CButton,
  CFormSelect,
} from '@coreui/react-pro';
import {
  isMobile,
  isMobileOnly,
  isTablet,
} from 'react-device-detect';
import BuyFertilizerModal from './BuyFertilizerModal';
import CashBidsModal from '../cash-bids/CashBidsModal';
import PurchaseContractModal from '../cash-bids/PurchaseContractModal';
import {
  fetchTableauToken,
  showBuyFertilizerModal,
  fetchCashBidLocationsWithoutFutures,
  userSelectedCashBidLocationWithoutFutures,
  fetchCashBidLocationAndShowModal,
} from './agronomy-actions';
import {
  useDispatch,
  useSelector,
} from 'react-redux';

const FertilizerVsCornFutures = () => {

  const dispatch = useDispatch();

  const {
    sidebarVisible,
    sidebarUnfoldable,
  } = useSelector(state => state.userSettings);

  const {
    tableauToken,
    locations,
    locationsDropDownListDataSource,
    selectedLocation,
  } = useSelector(state => state.agronomy);

  const growerId = useSelector(state => state.auth.authorization.growerId);

  const [windowWidth, setWindowWidth] = React.useState(window.innerWidth);

  const [windowHeight, setWindowHeight] = React.useState(window.innerHeight);

  React.useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
      setWindowHeight(window.innerHeight);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize)
  }, []); 

  React.useEffect(() => {
    dispatch(fetchTableauToken());
    dispatch(fetchCashBidLocationsWithoutFutures(false));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const height = windowHeight - 64 - (isMobile === true ? 150 : 75);

  var width = windowWidth;

  if (sidebarUnfoldable === true && sidebarVisible === true) {
    width -= 64;
  }
  else if (sidebarUnfoldable === false && sidebarVisible === true) {
    width -= 256;
  }

  return (
    <>
      <div style={{
        height: isMobile === true ? '150px' : '75px',
        width: width,
        justifyContent: 'flex-start', 
        alignContent: 'center',
        display: 'flex',
        paddingTop: '10px',
        paddingLeft: '14px',
        flexDirection: isMobile === true ? 'column' : 'row',
      }}>
        <CButton 
          color='primary'
          variant='outline'
          style={{width: 140, height: 58,}}
          onClick={() => dispatch(showBuyFertilizerModal())}>
          Buy Fertilizer
        </CButton>
        <div>&nbsp;&nbsp;&nbsp;</div>
        <CButton
          color='primary'
          variant='outline'
          style={{width: 140, height: 58,}}
          onClick={() => {
            if (Object.keys(selectedLocation).length === 0) {
              alert('You must select a location to sell grain.');
            }
            else {
              dispatch(fetchCashBidLocationAndShowModal());
            }
          }}>
          Sell Grain 
        </CButton>
        <div>&nbsp;&nbsp;&nbsp;</div>
        <CFormSelect
          floatingLabel='Select Location to Sell Grain'
          className='mb-3'
          style={{width: 300, lineHeight: 4,}}
          value={selectedLocation.locationId}
          options={locationsDropDownListDataSource}
          onChange={e => {
            var index = locations.findIndex(location => location.locationId.toString() === e.target.value);
            dispatch(userSelectedCashBidLocationWithoutFutures(locations[index], false));
          }} 
        />
      </div>
      <div style={{
        width: width,
        height: height,
        paddingTop: isMobile === true ? 20 : 0,}}
      >
        {
          tableauToken !== null ? (
            <>
              <tableau-viz
                src='https://prod-useast-b.online.tableau.com/t/premiercooperativeinc/views/FertilizervsFuturesPC/Home'
                token={tableauToken}
                toolbar='bottom'
                hide-tabs
                device={isMobileOnly === true ? 'phone' : 'desktop'}
                width={width}
                height={height}
                touch-optimize={isMobileOnly || isTablet ? true : undefined}>
                <viz-parameter name='Customer ID Parameter' value={growerId}></viz-parameter>
              </tableau-viz>
            </>
          ) : null
        }
      </div>
      <BuyFertilizerModal />
      <CashBidsModal />
      <PurchaseContractModal />
    </>
  );
}

export default FertilizerVsCornFutures;
